import Button from '@material-ui/core/Button';

import Checkbox from '@material-ui/core/Checkbox';

import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import Grid from '@material-ui/core/Grid';

import { makeStyles } from '@material-ui/core/styles';

import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

// import ThyroidReport from './ThyroidReport';

var timer = null; // To avoide duplicated randering

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '90% + 150px',
    backgroundColor: theme.palette.background.paper,
  },
  tableRightBorder : { borderWidth: 1, borderColor: 'black', borderStyle: 'solid'},
  tableRightBorderHeader : { borderWidth: 1, borderColor: 'white', borderStyle: 'solid'} 
}));

export default function ThyroidClinicalTable(props) {
  const classes = useStyles();

  const defaultValueClinic = JSON.parse(window.localStorage.getItem("noduleClinicDefault"));

//   console.log('-->1 ', JSON.parse(window.localStorage.getItem("noduleClinic")));
//   const [noduleClinicList, setNoduleClinicList] = React.useState(JSON.parse(window.localStorage.getItem("noduleClinic")));  
//   console.log('-->2 ', noduleClinicList);

//   useEffect(() => {    
//     console.log('thyroidClinicalTable - set noduleClic');
//     window.localStorage.setItem("noduleClinic", JSON.stringify(noduleClinicList));
//   }, [noduleClinicList]);

//   useEffect(() => {    
//     props.setNoduleClinic(JSON.parse(window.localStorage.getItem("noduleClinic")));
//   }, [props.noduleClinicProp]);

  const [historyDate, setHistoryDate] = React.useState(props.noduleClinic.historyDate[0]);
  const [historyDate1, setHistoryDate1] = React.useState(props.noduleClinic.historyDate[1]);
  const [historyDate2, setHistoryDate2] = React.useState(props.noduleClinic.historyDate[2]);
  const [historyTarget, setHistoryTarget] = React.useState(props.noduleClinic.history.target);
  const [historyPathologic, setHistoryPathologic] = React.useState(props.noduleClinic.history.pathologic);
  const [usCompareDate, setUsCompareDate] = React.useState(props.noduleClinic.usDate[0]);
  const [usCompareDate1, setUsCompareDate1] = React.useState(props.noduleClinic.usDate[1]);
  const [usCompareDate2, setUsCompareDate2] = React.useState(props.noduleClinic.usDate[2]);
  const [clinicalIndication, setClinicalIndication] = React.useState(props.noduleClinic.clinicEtc);

  const [rightSize, setRightSize] = React.useState(props.noduleClinic.rightValue[0]);
  const [rightSize1, setRightSize1] = React.useState(props.noduleClinic.rightValue[1]);
  const [rightSize2, setRightSize2] = React.useState(props.noduleClinic.rightValue[2]);

  const [leftSize, setLeftSize] = React.useState(props.noduleClinic.leftValue[0]);
  const [leftSize1, setLeftSize1] = React.useState(props.noduleClinic.leftValue[1]);
  const [leftSize2, setLeftSize2] = React.useState(props.noduleClinic.leftValue[2]);

  const [isthmusSize, setIsthumsSize] = React.useState(props.noduleClinic.isthmusValue[0]);
  const [isthmusSize1, setIsthumsSize1] = React.useState(props.noduleClinic.isthmusValue[1]);

  function handleClickRadioClinical(event) {
    if (event.target.value === props.noduleClinic.clinicalInformation) {
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.clinicalInformation = "";
        _noduleClinicList.clinicEtc = ""; // etc text value
        props.setNoduleClinic(_noduleClinicList);
    }
  }

  function handleClickRadioSize(event) {
    if (event.target.value === props.noduleClinic.size.sizeType) {
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.size.sizeType = "";
        props.setNoduleClinic(_noduleClinicList);    }
  }

  function handleClickRadioParen(event) {
    if (event.target.value === props.noduleClinic.parenchymalEchotexture) {
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.parenchymalEchotexture = "";
        props.setNoduleClinic(_noduleClinicList);    }
  }

  function handleClickRadioVas(event) {
    if (event.target.value === props.noduleClinic.parenchymalVascularity) {
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.parenchymalVascularity = "";
        props.setNoduleClinic(_noduleClinicList);    }
  }

  function handleHistoryDataChange(e, index) {
    clearTimeout(timer);
    timer = setTimeout(()=>{
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.historyDate[index] = e.target.value;
        props.setNoduleClinic(_noduleClinicList);
    }, 500)
  }

  function handleHistoryDataChangeClearTimer(e, index){
    clearTimeout(timer);
    var _noduleClinicList = {...props.noduleClinic};
    _noduleClinicList.historyDate[index] = e.target.value;
    props.setNoduleClinic(_noduleClinicList);
  }

  function handleHistoryTargetChange(e){
    clearTimeout(timer);
    timer = setTimeout(()=>{
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.history.target = e.target.value;
        props.setNoduleClinic(_noduleClinicList);
    }, 500)
  }

  function handleHistoryTargetChangeClearTimer(e){
    clearTimeout(timer);
    var _noduleClinicList = {...props.noduleClinic};
    _noduleClinicList.history.target = e.target.value;
    props.setNoduleClinic(_noduleClinicList);
  }
  
  function handlePathogicTargetChange(e){
    clearTimeout(timer);
    timer = setTimeout(()=>{
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.history.pathologic = e.target.value;
        props.setNoduleClinic(_noduleClinicList);
    }, 500)
  }

  function handlePathogicTargetChangeClearTimer(e){
    clearTimeout(timer);
    var _noduleClinicList = {...props.noduleClinic};
    _noduleClinicList.history.pathologic = e.target.value;
    props.setNoduleClinic(_noduleClinicList);
  }

  function handleUSCompareDateChange(e, index){
    clearTimeout(timer);
    timer = setTimeout(()=>{
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.usDate[index] = e.target.value;
        props.setNoduleClinic(_noduleClinicList);
    }, 500)
  }

  function handleUSCompareDateChangeClearTimer(e, index) {
    clearTimeout(timer);
    var _noduleClinicList = {...props.noduleClinic};
    _noduleClinicList.usDate[index] = e.target.value;
    props.setNoduleClinic(_noduleClinicList);
  }

  function handleClinicalIndicationChange(e){
    clearTimeout(timer);
    timer = setTimeout(()=>{
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.clinicEtc = e.target.value;
        props.setNoduleClinic(_noduleClinicList);
    }, 500)
  }

  function handleClinicalIndicationChangeClearTimer(e){
    clearTimeout(timer);
    var _noduleClinicList = {...props.noduleClinic};
    _noduleClinicList.clinicEtc = e.target.value;
    props.setNoduleClinic(_noduleClinicList);
  }

  function handleThyroidSizeRightChange(e, index){
    clearTimeout(timer);
    timer = setTimeout(()=>{
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.rightValue[index] = e.target.value;
        props.setNoduleClinic(_noduleClinicList);
    }, 500)
  }
  
  function handleThyroidSizeRightChangeClearTimer(e, index) {
    clearTimeout(timer);
    var _noduleClinicList = {...props.noduleClinic};
    _noduleClinicList.rightValue[index] = e.target.value;
    props.setNoduleClinic(_noduleClinicList);
  }

  function handleThyroidSizeLeftChange(e, index){
    clearTimeout(timer);
    timer = setTimeout(()=>{
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.leftValue[index] = e.target.value;
        props.setNoduleClinic(_noduleClinicList);
    }, 500)
  }

  function handleThyroidSizeLeftChangeClearTimer(e, index){
    clearTimeout(timer);
    var _noduleClinicList = {...props.noduleClinic};
    _noduleClinicList.leftValue[index] = e.target.value;
    props.setNoduleClinic(_noduleClinicList);
  }

  function handleThyroidSizeIsthumsChange(e, index){
    clearTimeout(timer);
    timer = setTimeout(()=>{
        var _noduleClinicList = {...props.noduleClinic};
        _noduleClinicList.isthmusValue[index] = e.target.value;
        props.setNoduleClinic(_noduleClinicList);
    }, 500)
  }

  function handleThyroidSizeIsthumsChangeClearTimer(e, index){
    clearTimeout(timer);
    var _noduleClinicList = {...props.noduleClinic};
    _noduleClinicList.isthmusValue[index] = e.target.value;
    props.setNoduleClinic(_noduleClinicList);
  }

  return (
    <div className={classes.root}> 
        <Grid container spacing={24}>
            <Grid item xs={12} sm={12} container justify="flex-end">
                <Button variant="contained" color='secondary' startIcon={<DeleteOutlineIcon />} onClick={(event) => {
                    var _noduleClinicList = {...defaultValueClinic};
                    _noduleClinicList.normalThy = true;
                    props.deleteThyroid(true); // 갑상선 메인 테이블 (위치별) 디폴트 값으로 적용
                    //window.localStorage.setItem("noduleClinic", JSON.stringify(_noduleClinicList));
                    props.setNoduleClinic(_noduleClinicList);}} style={{backgroundColor:'#C71585', color:'white', marginTop:'10px', marginBottom:'10px', zIndex:0}} >갑상선 초기화</Button>
            </Grid>
            <Grid item xs={12} sm={12} container justify="flex-end">
                <TableBody>
                    <TableCell align="right" size="small" className={classes.tableRightBorder}>
                        <FormControlLabel control={<Checkbox name="normal" 
                            defaultChecked={props.noduleClinic.normalThy}
                            checked = {props.noduleClinic.normalThy}
                            size='small'
                            onChange={(event) => { 
                                var _noduleClinicList = {...props.noduleClinic};
                                _noduleClinicList.normalThy = event.target.checked;
                                props.setNoduleClinic(_noduleClinicList);
                            }}
                            color="primary"/>} label="Normal Thyroid"/>
                    </TableCell>
                </TableBody>
            </Grid>
        </Grid>
        <Table size='small' className={classes.table} style={{marginTop:'10px', marginBottom:'10px'}} aria-label="simple table">
            <TableBody>
                <TableCell align="center" style={{backgroundColor:"grey"}}></TableCell>
                    <TableCell align="center" colSpan={5} style={{backgroundColor:"grey", color:'white'}}>Clinical Information</TableCell>
            </TableBody>
            <TableBody>
            <TableCell align="center" style={{width:'50px'}} className={classes.tableRightBorder}>Clinical Indication</TableCell>
                <TableCell align="center" className={classes.tableRightBorder} colSpan={5}>
                    <RadioGroup row aria-label="position" name="position" value={props.noduleClinic.clinicalInformation}
                        onChange={(event) => {
                            var _noduleClinicList = {...props.noduleClinic};
                            _noduleClinicList.clinicalInformation = event.target.value;
                            _noduleClinicList.normalThy = false; // when any input, disable normal thyroid 
                            if(event.target.value !== 'etcInput'){_noduleClinicList.clinicEtc = '';}
                            props.setNoduleClinic(_noduleClinicList);
                            }}>
                        <FormControlLabel value="Diagnostic workup" /*disabled={props.noduleClinic.normalThy}*/ control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={handleClickRadioClinical}/>} label="Diagnostic workup" labelPlacement="end" />
                        <FormControlLabel value="Thyroid nodule" /*disabled={props.noduleClinic.normalThy}*/ control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={handleClickRadioClinical}/>} label="(default) Thyroid nodule" labelPlacement="end" />
                        {/* <FormControlLabel value="Thyroiditis" control={<Radio color="primary" size='small' onClick={handleClickRadioClinical}/>} label="Thyroiditis" labelPlacement="end"/>   */}
                        <FormControlLabel value= "etcInput" /*disabled={props.noduleClinic.normalThy}*/ control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={handleClickRadioClinical}/>} label={
                            <TextField id="outlined-basic" disabled={props.noduleClinic.clinicalInformation !== 'etcInput' || props.noduleClinic.normalThy} defaultValue={clinicalIndication} value={clinicalIndication} size="small" onChange={(event) => {
                                setClinicalIndication(event.target.value);
                                handleClinicalIndicationChange(event);
                                }} onBlur={(event) => {
                                    handleClinicalIndicationChangeClearTimer(event);
                                }}/>
                        } />
                    </RadioGroup>
                </TableCell>
            </TableBody>
            <TableBody>
                <TableCell align="center" className={classes.tableRightBorder}>Previous Biopsy</TableCell>
                    <TableCell align="left" className={classes.tableRightBorder} colSpan={5}>
                        <RadioGroup row aria-label="position" name="position" value={props.noduleClinic.history.hisType}
                            onChange={(event) => {
                                var _noduleClinicList = {...props.noduleClinic};
                                _noduleClinicList.history.hisType = event.target.value;
                                _noduleClinicList.normalThy = false; // when any input, disable normal thyroid 
                                props.setNoduleClinic(_noduleClinicList);
                                }}>
                            <div style={{marginTop:'10px'}}>Date (<TextField id="outlined-basic" size="small" disabled={props.noduleClinic.normalThy} style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={historyDate} value={historyDate}
                                onChange={(event) => { 
                                    setHistoryDate(event.target.value);
                                    handleHistoryDataChange(event, 0);} } onBlur={(event) => {handleHistoryDataChangeClearTimer(event, 0)}}/>. <TextField id="outlined-basic" size="small" disabled={props.noduleClinic.normalThy} style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={historyDate1} value={historyDate1}
                                onChange={(event) => { 
                                    setHistoryDate1(event.target.value);
                                    handleHistoryDataChange(event, 1);} } onBlur={(event) => {handleHistoryDataChangeClearTimer(event, 1)}}/>. <TextField id="outlined-basic" size="small" disabled={props.noduleClinic.normalThy} style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={historyDate2} value={historyDate2}
                                onChange={(event) => { 
                                    setHistoryDate2(event.target.value);
                                    handleHistoryDataChange(event, 2);} } onBlur={(event) => {handleHistoryDataChangeClearTimer(event, 2)}}/>), &nbsp; 
                            Target nodule (<TextField id="outlined-basic" size="small" style={{width:'200px'}} disabled={props.noduleClinic.normalThy} inputProps={{style: { textAlign: 'center' }}} defaultValue={historyTarget} value={historyTarget} 
                                onChange={(event) => {
                                    setHistoryTarget(event.target.value);
                                    handleHistoryTargetChange(event);} } onBlur={(event) => {
                                        handleHistoryTargetChangeClearTimer(event);
                                    }}/>) &nbsp; 
                            <FormControlLabel control={<Checkbox name="fna" color="primary" disabled ={props.noduleClinic.normalThy} 
                                defaultChecked={props.noduleClinic.history.fna} size='small' checked={props.noduleClinic.history.fna}
                                onChange={(event) => {
                                    var _noduleClinic = {...props.noduleClinic};
                                    _noduleClinic.history.fna = event.target.checked;
                                    props.setNoduleClinic(_noduleClinic);}}/>} label="FNA"/>
                            <FormControlLabel control={<Checkbox name="cnb" color="primary" 
                                disabled={props.noduleClinic.normalThy}
                                defaultChecked={props.noduleClinic.history.cnb} size='small' checked={props.noduleClinic.history.cnb}
                                onChange={(event) => {
                                    var _noduleClinic = {...props.noduleClinic};
                                    _noduleClinic.history.cnb = event.target.checked;
                                    props.setNoduleClinic(_noduleClinic);}}/>} label="CNB"/>

                            , Pathologic Diagnosis (<TextField id="outlined-basic" size="small" style={{width:'200px'}} disabled={props.noduleClinic.normalThy} inputProps={{style: { textAlign: 'center' }}} defaultValue={historyPathologic} value={historyPathologic} 
                            onChange={(event) => {
                                setHistoryPathologic(event.target.value);
                                handlePathogicTargetChange(event);} } onBlur={(event) => {
                                    handlePathogicTargetChangeClearTimer(event);
                                }}/>)</div>
                        </RadioGroup>
                    </TableCell>
            </TableBody>
            <TableBody>
                <TableCell align="center" className={classes.tableRightBorder}>US Comparision</TableCell>
                    <TableCell align="left" className={classes.tableRightBorder} colSpan={5}>
                        <div style={{marginTop:'10px'}}>Date (<TextField id="outlined-basic" size="small" style={{width:'50px'}} disabled={props.noduleClinic.normalThy} inputProps={{style: { textAlign: 'center' }}} defaultValue={usCompareDate} value={usCompareDate} 
                            onChange={(event) => {
                                setUsCompareDate(event.target.value);
                                handleUSCompareDateChange(event, 0);} } onBlur={(event) => {handleUSCompareDateChangeClearTimer(event, 0)}}/>. <TextField id="outlined-basic" size="small" style={{width:'50px'}} disabled={props.noduleClinic.normalThy} inputProps={{style: { textAlign: 'center' }}} defaultValue={usCompareDate1} value={usCompareDate1}
                            onChange={(event) => {
                                setUsCompareDate1(event.target.value);
                                handleUSCompareDateChange(event, 1);} } onBlur={(event) => {handleUSCompareDateChangeClearTimer(event, 1)}}/>. <TextField id="outlined-basic" size="small" style={{width:'50px'}} disabled={props.noduleClinic.normalThy} inputProps={{style: { textAlign: 'center' }}} defaultValue={usCompareDate2} value={usCompareDate2}
                            onChange={(event) => {
                                setUsCompareDate2(event.target.value);
                                handleUSCompareDateChange(event, 2);} } onBlur={(event) => {handleUSCompareDateChangeClearTimer(event, 2)}}/>)</div>
                    </TableCell>
            </TableBody>
            <TableBody>
                <TableCell align="center" style={{backgroundColor:"grey"}}></TableCell>
                    <TableCell align="center" colSpan={5} style={{backgroundColor:"grey", color:'white'}}>Thyroid Parenchyma</TableCell>
            </TableBody>
            <TableBody>
                <TableCell align="center" className={classes.tableRightBorder}>Thyroid Size</TableCell>
                    <TableCell align="left" className={classes.tableRightBorder} colSpan={5}>
                        <RadioGroup row aria-label="position" name="position" value={props.noduleClinic.size.sizeType}
                        onChange={(event) => {
                            var _noduleClinicList = {...props.noduleClinic};
                            _noduleClinicList.size.sizeType = event.target.value;
                            _noduleClinicList.normalThy = false; // when any input, disable normal thyroid 
                            props.setNoduleClinic(_noduleClinicList);
                            }}>
                            <FormControlLabel value="Decreased" control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={handleClickRadioSize}/>} label="Decreased" labelPlacement="end" />
                            <FormControlLabel value="Normal" control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={handleClickRadioSize}/>} label="Normal" labelPlacement="end" />
                            <FormControlLabel value="Increased" control={<Radio color="primary" size='small' disabled={props.noduleClinic.normalThy} onClick={handleClickRadioSize}/>} label="Increased" labelPlacement="end"/>
                        </RadioGroup>
                        <FormControlLabel control={<Checkbox name="right" 
                            defaultChecked={props.noduleClinic.size.right} disabled={props.noduleClinic.normalThy} checked={props.noduleClinic.size.right} size='small'
                            onChange={(event) => { 
                                var _noduleClinicList = {...props.noduleClinic};
                                _noduleClinicList.size.right = event.target.checked;
                                _noduleClinicList.normalThy = false; // when any input, disable normal thyroid 
                                props.setNoduleClinic(_noduleClinicList);
                            }} 
                            color="primary"/>} label="Right"/>
                        (<TextField id="outlined-basic" size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={rightSize} value={rightSize} disabled={!props.noduleClinic.size.right || props.noduleClinic.normalThy}
                            placeholder = "AP"
                            onChange={(event) => {
                                setRightSize(event.target.value);
                                handleThyroidSizeRightChange(event, 0);
                                } } onBlur={(event) => {
                                    handleThyroidSizeRightChangeClearTimer(event, 0)
                                }}/> X 
                        <TextField id="outlined-basic" size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={rightSize1} value={rightSize1} disabled={!props.noduleClinic.size.right || props.noduleClinic.normalThy}
                            placeholder = "T"
                            onChange={(event) => {
                                setRightSize1(event.target.value);
                                handleThyroidSizeRightChange(event, 1);} }onBlur={(event) => {
                                    handleThyroidSizeRightChangeClearTimer(event, 1)
                                }}/> X 
                        <TextField id="outlined-basic" size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={rightSize2} value={rightSize2} disabled={!props.noduleClinic.size.right || props.noduleClinic.normalThy}
                            placeholder = "L" 
                            onChange={(event) => {
                                setRightSize2(event.target.value);
                                handleThyroidSizeRightChange(event, 2);} } onBlur={(event) => {
                                    handleThyroidSizeRightChangeClearTimer(event, 2)
                                }}/>) &nbsp;
                                <select name="unit" disabled={!props.noduleClinic.size.right || props.noduleClinic.normalThy} value={props.noduleClinic.rightValue[3]} onChange={(event) => {   
                                    var _noduleClinicList = {...props.noduleClinic};
                                    _noduleClinicList.rightValue[3] = event.target.value;
                                    _noduleClinicList.leftValue[3] = event.target.value;
                                    _noduleClinicList.isthmusValue[2] = event.target.value;
                                    props.setNoduleClinic(_noduleClinicList);
                                }}>
                                    <option value="cm">cm</option>
                                    <option value="mm">mm</option>
                                </select>
                                <br/>
                        
                        <FormControlLabel control={<Checkbox name="isth" 
                            defaultChecked={props.noduleClinic.size.isthmus} disabled={props.noduleClinic.normalThy} checked={props.noduleClinic.size.isthmus} size='small'
                            onChange={(event) => { 
                                var _noduleClinicList = {...props.noduleClinic};
                                _noduleClinicList.size.isthmus = event.target.checked;
                                _noduleClinicList.normalThy = false; // when any input, disable normal thyroid 
                                props.setNoduleClinic(_noduleClinicList);
                            }}
                            color="primary"/>} label="Isthmus"/>
                        (<TextField id="outlined-basic" size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={isthmusSize} value={isthmusSize} disabled={!props.noduleClinic.size.isthmus || props.noduleClinic.normalThy}
                            placeholder = "AP"
                            onChange={(event) => {
                                setIsthumsSize(event.target.value);
                                handleThyroidSizeIsthumsChange(event, 0);} } onBlur={(event) => {
                                    handleThyroidSizeIsthumsChangeClearTimer(event, 0);
                                }}/> X 
                        <TextField id="outlined-basic" size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={isthmusSize1} value={isthmusSize1} disabled={!props.noduleClinic.size.isthmus || props.noduleClinic.normalThy}
                            placeholder = "L"
                            onChange={(event) => { 
                                setIsthumsSize1(event.target.value);
                                handleThyroidSizeIsthumsChange(event, 1);} }onBlur={(event) => {
                                    handleThyroidSizeIsthumsChangeClearTimer(event, 1);
                                }}/>) &nbsp;
                                <select name="unit" disabled={!props.noduleClinic.size.isthmus} value={props.noduleClinic.isthmusValue[2]} onChange={(event) => {   
                                        var _noduleClinicList = {...props.noduleClinic};
                                        _noduleClinicList.isthmusValue[2] = event.target.value;
                                        _noduleClinicList.rightValue[3] = event.target.value;
                                        _noduleClinicList.leftValue[3] = event.target.value;
                                        props.setNoduleClinic(_noduleClinicList);
                                }}>
                                    <option value="cm">cm</option>
                                    <option value="mm">mm</option>
                                </select><br/>

                        <FormControlLabel control={<Checkbox name="left" disabled={props.noduleClinic.normalThy}
                            defaultChecked={props.noduleClinic.size.left} checked={props.noduleClinic.size.left}
                            size='small'
                            onChange={(event) => { 
                                var _noduleClinicList = {...props.noduleClinic};
                                _noduleClinicList.size.left = event.target.checked;
                                _noduleClinicList.normalThy = false; // when any input, disable normal thyroid 
                                props.setNoduleClinic(_noduleClinicList);
                            }}
                            color="primary"/>} label="Left"/>
                        (<TextField id="outlined-basic" size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={leftSize} value={leftSize} disabled={!props.noduleClinic.size.left || props.noduleClinic.normalThy}
                            placeholder = "AP"
                            onChange={(event) => {
                                setLeftSize(event.target.value);
                                handleThyroidSizeLeftChange(event, 0);} } onBlur={(event) => {
                                    handleThyroidSizeLeftChangeClearTimer(event, 0);
                                }}/> X 
                        <TextField id="outlined-basic" size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}} defaultValue={leftSize1} value={leftSize1} disabled={!props.noduleClinic.size.left || props.noduleClinic.normalThy}
                            placeholder = "T"
                            onChange={(event) => {
                                setLeftSize1(event.target.value);
                                handleThyroidSizeLeftChange(event, 1);} }onBlur={(event) => {
                                    handleThyroidSizeLeftChangeClearTimer(event, 1);
                                }}/> X 
                        <TextField id="outlined-basic" size="small" style={{width:'50px'}} inputProps={{style: { textAlign: 'center' }}}  defaultValue={leftSize2} value={leftSize2} disabled={!props.noduleClinic.size.left || props.noduleClinic.normalThy}
                            placeholder = "L"
                            onChange={(event) => { 
                                setLeftSize2(event.target.value);
                                handleThyroidSizeLeftChange(event, 2);} }onBlur={(event) => {
                                    handleThyroidSizeLeftChangeClearTimer(event, 2);
                                }}/>) &nbsp;
                                <select name="unit" disabled={!props.noduleClinic.size.left} value={props.noduleClinic.leftValue[3]} onChange={(event) => {   
                                        var _noduleClinicList = {...props.noduleClinic};
                                        _noduleClinicList.leftValue[3] = event.target.value;
                                        _noduleClinicList.rightValue[3] = event.target.value;
                                        _noduleClinicList.isthmusValue[2] = event.target.value;
                                        props.setNoduleClinic(_noduleClinicList);
                                }}>
                                    <option value="cm">cm</option>
                                    <option value="mm">mm</option>
                                </select> <br/>
                    </TableCell>
            </TableBody>
            <TableBody>
                <TableCell align="center" className={classes.tableRightBorder}>Diffuse Thyroid Disease</TableCell>
                    <TableCell align="left" className={classes.tableRightBorder}>
                        <FormControlLabel control={<Checkbox name="yes" color="primary" size='small' disabled={props.noduleClinic.normalThy}
                        defaultChecked={props.noduleClinic.diffusionThyroidDisease} checked={props.noduleClinic.diffusionThyroidDisease} 
                        onChange={(event) => {
                            var _noduleClinicList = {...props.noduleClinic};
                            _noduleClinicList.diffusionThyroidDisease = event.target.checked;
                            _noduleClinicList.normalThy = false; // when any input, disable normal thyroid 
                            props.setNoduleClinic(_noduleClinicList);}}/>} label="Yes"/>
                    </TableCell>
                    <TableCell align="center" className={classes.tableRightBorder}>Parenchymal echotexture</TableCell>
                    <TableCell align="left" className={classes.tableRightBorder}>
                        <RadioGroup row aria-label="position" name="position" value={props.noduleClinic.parenchymalEchotexture}
                        onChange={(event) => {
                            var _noduleClinicList = {...props.noduleClinic};
                            _noduleClinicList.parenchymalEchotexture = event.target.value;
                            props.setNoduleClinic(_noduleClinicList);
                            }}>
                            <FormControlLabel value="Homo" disabled={props.noduleClinic.diffusionThyroidDisease === false || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={handleClickRadioParen}/>} label="Homo" labelPlacement="end" />
                            <FormControlLabel value="Hetero" disabled={props.noduleClinic.diffusionThyroidDisease === false || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={handleClickRadioParen}/>} label="Hetero" labelPlacement="end" />
                        </RadioGroup>
                    </TableCell>
                    <TableCell align="center" className={classes.tableRightBorder}>Parenchymal Vascularity</TableCell>
                    <TableCell align="left" className={classes.tableRightBorder}>
                        <RadioGroup row aria-label="position" name="position" value={props.noduleClinic.parenchymalVascularity}
                        onChange={(event) => {
                            var _noduleClinicList = {...props.noduleClinic};
                            _noduleClinicList.parenchymalVascularity = event.target.value;
                            _noduleClinicList.normalThy = false; // when any input, disable normal thyroid 
                            props.setNoduleClinic(_noduleClinicList);
                            }}>
                            <FormControlLabel value="Normal" disabled={props.noduleClinic.diffusionThyroidDisease === false || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={handleClickRadioVas}/>} label="Normal" labelPlacement="end" />
                            <FormControlLabel value="Incrased" disabled={props.noduleClinic.diffusionThyroidDisease === false || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={handleClickRadioVas}/>} label="Increased" labelPlacement="end" />
                            <FormControlLabel value="Decreased" disabled={props.noduleClinic.diffusionThyroidDisease === false || props.noduleClinic.normalThy} control={<Radio color="primary" size='small' onClick={handleClickRadioVas}/>} label="Decreased" labelPlacement="end" />
                        </RadioGroup>
                    </TableCell>
            </TableBody>
            <TableBody>
                <TableCell align="center" className={classes.tableRightBorder}>Multinodular Goiter</TableCell>
                <TableCell align="left" className={classes.tableRightBorder} colSpan={5}>
                    <FormControlLabel control={<Checkbox name="yes" color="primary" size='small'
                    disabled={props.noduleClinic.normalThy}
                    defaultChecked={props.noduleClinic.multinodule} checked={props.noduleClinic.multinodule} 
                    onChange={(event) => {
                        var _noduleClinicList = {...props.noduleClinic};
                        _noduleClinicList.multinodule = event.target.checked;
                        _noduleClinicList.normalThy = false; // when any input, disable normal thyroid 
                        props.setNoduleClinic(_noduleClinicList);}}/>} label="Yes"/>
                </TableCell>
            </TableBody>
        </Table>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            {/* <Button variant="contained" color='primary' startIcon={<RemoveIcon />} onClick={removeNodule} style={{marginRight:'10px', marginTop:'10px'}} disabled={props.noduleClinic.length === 1}>Remove Nodule</Button> */}
            {/* <Button variant="contxained" color='primary' startIcon={<AddIcon />} onClick={addNodule} style={{marginTop:'10px'}} disabled={props.noduleClinic.length === 10}>Add Nodule</Button> */}
          </Grid>
      </Grid>
    </div>
  );
}